export default "__VITE_PUBLIC_ASSET__3796cc5d__"